module.exports = __webpack_public_path__ + "static/predikt-fda6991d675de8b69e71bda24233829c.png";